module.exports = __webpack_public_path__ + "img/left_1_hover.96734c1f.png";